export const transactionTableHead = [
    {
        title: "Payout Date And Time",
        key: "payoutDate",
        dataIndex: "payoutDate",
        width: "20%"
    },
    {
        title: "Transaction Id",
        key: "transactionId",
        dataIndex: "transactionId",
        width: "20%"
    },
    {
        title: "Pay Mode",
        key: "payMode",
        dataIndex: "payMode",
        width: "20%"
    },
    {
        title: "Status",
        key: "status",
        dataIndex: "status",
        width: "20%"
    },
    {
        title: "Amount Paid",
        key: "amountPaid",
        dataIndex: "amountPaid",
        width: "20%"
    }
];